itsoftApp.createModule("addingToComparison", ["popups"], function () {
    var comparisonButtons = document.querySelectorAll("[data-product-id]");
    var comparisonCount = document.querySelector(".js-comparison-count");
    var deletePopup = document.querySelector("#comparison-info-delete");
    var addPopup = document.querySelector("#comparison-info-add");
    var overflowPopup = document.querySelector("#comparison-info-overflow");
    var addedToComparisonClass = "page__comparison-link--added";
    var currentButton;

    var sendRequest = function (URL, data, onProcessResponse) {
        // var xhr = new XMLHttpRequest();

        // xhr.addEventListener("load", function () {
        //     if (onProcessResponse) {
        //         onProcessResponse({
        //             STATUS: "OK"
        //         }); // xhr.response
        //     }
        // });

        // xhr.open("GET", URL);
        // xhr.send(data);
        // 
        BX.ajax.loadJSON(
            URL,
            data,
            onProcessResponse
        );
    }

    var onComparisonDelete = function (data) {
        currentButton.classList.remove(addedToComparisonClass);
        currentButton = "";
        comparisonCount.textContent = data.COUNT;
        deletePopup.dispatchEvent(openEvent);
    }

    var onComparisonAdd = function (data) {
        if (data.STATUS === "OK") {
            currentButton.classList.add(addedToComparisonClass);
            comparisonCount.textContent = data.COUNT;
            addPopup.dispatchEvent(openEvent);
        } else if (data.STATUS === "ERROR") {
            overflowPopup.dispatchEvent(openEvent);
        }
    }

    var onComparisonButtonClick = function (evt) {
        evt.preventDefault();
        var data = "";
        var productID = this.getAttribute("data-product-id");
        currentButton = this;

        if (!productID) {
            return;
        }

        if (currentButton.classList.contains("js-card-comparison")) {
            var URL = "../";
        } else {
            var URL = "./";
        }

        if (this.classList.contains(addedToComparisonClass)) {
            data = "action=DELETE_FROM_COMPARE_LIST&id=" + productID + "&ajax_action=Y";
            sendRequest(URL, data, onComparisonDelete);
        } else {
            data = "action=ADD_TO_COMPARE_LIST&id=" + productID + "&ajax_action=Y";
            sendRequest(URL, data, onComparisonAdd);
        }
    }

    if (comparisonButtons) {
        Array.prototype.forEach.call(comparisonButtons, function (comparisonButton) {
            comparisonButton.addEventListener("click", onComparisonButtonClick);
        });
    }
});